export default "__VITE_ASSET__DI15a_zZ__"